/* loads in public pages eg, auth */
$(function () {
    $(".form-multiselect").select2({
        placeholder: "Select Your Options",
        allowClear: true,
    });

    $(".form-item.input-file").on("change", 'input[type="file"]', function () {
        var filename = $(this).val().split("\\").pop();
        $(this)
            .parent()
            .find(".form-file-name")
            .html(
                '<i class="far fa-check mr-2"></i>File selected: ' + filename
            );
    });

    $(".form-item.password").on("click", ".toggle-password", function () {
        $(this).toggleClass("fa-eye fa-eye-slash");
        var input = $($(this).siblings("input"));
        if (input.attr("type") == "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    });
});
